import { Button, Result } from 'antd';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../helpers/use-store';
import { useNotification } from '../../hooks/use-notification';
import { useTranslation } from 'react-i18next';

const ConfirmPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { confirmCode } = useParams<{ confirmCode: string }>();
  const {
    dataStore: { userStore },
  } = useStore();
  const notificationApi = useNotification();

  useEffect(() => {
    const init = async () => {
      if (confirmCode) {
        try {
          await userStore.confirm(confirmCode);
        } catch (e) {
          notificationApi.error({
            placement: 'top',
            icon: '',
            message: t('common.error'),
            description: t('auth.confirm.verified'),
          });

          navigate('/login');
        }
      }
    };

    init();
  }, [confirmCode]);

  if (!confirmCode) {
    return (
      <Result
        status="404"
        title="404"
        subTitle={t('notFound.subtitle')}
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            {t('common.back')}
          </Button>
        }
      />
    );
  }

  return null;
};

export default ConfirmPage;
